module.exports = __webpack_public_path__ + "img/app.825ab308.png";